<template>
  <p>Registration for VIZBI 2015 is now closed.</p>
  <p>
    Members of the <a href="http://iscb.org/">International Society for Computational Biology
      (ISCB)</a> received a registration discount, as well as
    <a href="http://www.iscb.org/iscb-membership">other membership benefits</a>.
  </p>
  <h4>Virtual Participation</h4>
  <p>
    VIZBI 2015 virtual participants were able to access a live web stream of all scheduled talks
    during the main conference (not tutorials). Virtual participants could also upload a short video
    screened during one of the Lightning Talk sessions &mdash; see the
    <router-link to="Posters#Virtual">Posters page</router-link> for details.
  </p>
</template>

<style scoped>
p:not(:first-child) {
  margin-top: 12px;
}
</style>
